// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"db1fac18717eaf10","930":"5cbe2d68093f4212"}[chunkId] + ".css";
};